import Footer from './Footer';
import React from 'react';
import Spinner from './Spinner';
const pfLogo = '/assets/images/logo.svg';
const stripe = '/assets/images/racing-stripe.svg';

const AppNotSupportedMessage = ({ isLoading, practiceName }) => {
    return (
        <div className="flex-column fill-space--relative">
            <div className="pf-header hidden--xs">
                <div className="pf-logo"><img src={pfLogo} width="190" alt="practice fusion logo" /></div>
            </div>
            <div className="racing-stripe hidden--xs">
                <div className="racing-stripe__container">
                    <img className="racing-stripe__img" src={stripe} alt="" />
                </div>
            </div>
            <div className="overflow-auto padding-Alg scope-selection">
                <h3>This application is not currently supported by {practiceName}</h3>
                <div className="disclaimer">
                    Patient Fusion is no longer being used by {practiceName} for authorizing access to your data.
                    This application needs to update its connection to continue to share your data.
                    Please contact the application provider to ask when they will complete this update.
                </div>
            </div>
            <Footer />
            <Spinner isLoading={isLoading} />
        </div>
    );
};

export default AppNotSupportedMessage;